<script setup></script>

<template>
    <div class="layout-footer">
        Powered by
        <a href="#" rel="noopener noreferrer" class="text-primary font-bold hover:underline">Solution Experts</a>
    </div>
</template>
